import { render, staticRenderFns } from "./PostCommon.vue?vue&type=template&id=e8b2a194&"
import script from "./PostCommon.vue?vue&type=script&lang=js&"
export * from "./PostCommon.vue?vue&type=script&lang=js&"
import style0 from "./PostCommon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports